/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

export const VALIDATION_TYPE_MAP = [
  { key: 'none', value: 'none', text: 'None', regex: '', example: '' },
  { key: 'email', value: 'email', text: 'Email', regex: '^[\\w._%+-]+@[\\w.-]+\\.[A-Za-z]{2,}$', example: '' },
  { key: 'phone_digits_only', value: 'phone_digits_only', text: 'Phone (Digits Only)', regex: '^\\d{7,15}$', example: '' },
  { key: 'phone_intl', value: 'phone_intl', text: 'Phone (Intl Format)', regex: '^\\+?[1-9]\\d{6,14}$', example: '' },
  { key: 'number_integer', value: 'number_integer', text: 'Number (Integer)', regex: '^-?\\d+$', example: '' },
  { key: 'number_decimal', value: 'number_decimal', text: 'Number (Decimal)', regex: '^-?\\d*(\\.\\d+)?$', example: '' },
  { key: 'number_positive', value: 'number_positive', text: 'Positive Number', regex: '^\\d+(\\.\\d+)?$', example: '' },
  { key: 'currency_two_decimals', value: 'currency_two_decimals', text: 'Currency (2 decimals)', regex: '^\\d+(\\.\\d{1,2})?$', example: '' },
  { key: 'percentage', value: 'percentage', text: 'Percentage (0 - 100)', regex: '^(100(?:\\.0{1,2})?|(?:\\d{1,2}(?:\\.\\d{1,2})?))$', example: '' },
  { key: 'date_ymd_dash', value: 'date_ymd_dash', text: 'Date (YYYY-MM-DD)', regex: '^\\d{4}-\\d{2}-\\d{2}$', example: '' },
  { key: 'date_dmy_slash', value: 'date_dmy_slash', text: 'Date (DD/MM/YYYY)', regex: '^\\d{2}\\/\\d{2}\\/\\d{4}$', example: '' },
  { key: 'date_mdy_slash', value: 'date_mdy_slash', text: 'Date (MM/DD/YYYY)', regex: '^\\d{2}\\/\\d{2}\\/\\d{4}$', example: '' },
  { key: 'date_ymd_slash', value: 'date_ymd_slash', text: 'Date (YYYY/MM/DD)', regex: '^\\d{4}\\/\\d{2}\\/\\d{2}$', example: '' },
  { key: 'date_dmy_dash', value: 'date_dmy_dash', text: 'Date (DD-MM-YYYY)', regex: '^\\d{2}-\\d{2}-\\d{4}$', example: '' },
  { key: 'date_dmy_dot', value: 'date_dmy_dot', text: 'Date (DD.MM.YYYY)', regex: '^\\d{2}\\.\\d{2}\\.\\d{4}$', example: '' },
  { key: 'date_Mdy_space', value: 'date_Mdy_space', text: 'Date (Month name DD, YYYY)', regex: '^(January|February|March|April|May|June|July|August|September|October|November|December)\\s(0[1-9]|[12][0-9]|3[01]),\\s\\d{4}$', example: 'August 03, 2025' },
  { key: 'date_my_dash', value: 'date_my_dash', text: 'Month-Year (MM-YYYY)', regex: '^(0[1-9]|1[0-2])-\\d{4}$', example: '10-2025' },
  { key: 'date_ym_dash', value: 'date_ym_dash', text: 'Month-Year (YYYY-MM)', regex: '^\\d{4}-(0[1-9]|1[0-2])$', example: '2025-10' },
  { key: 'date_y_only', value: 'date_y_only', text: 'Year Only (YYYY)', regex: '^\\d{4}$', example: '2025' },
  { key: 'time_Hm_doubledot', value: 'time_Hm_doubledot', text: 'Time (HH:MM, 24h)', regex: '^(?:[01]\\d|2[0-3]):[0-5]\\d$', example: '14:35' },
  { key: 'time_Hms_doubledot', value: 'time_Hms_doubledot', text: 'Time (HH:MM:SS, 24h)', regex: '^(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d$', example: '14:35:41' },
  { key: 'time_hma_doubledot', value: 'time_hma_doubledot', text: 'Time (HH:MM AM/PM)', regex: '^(0?[1-9]|1[0-2]):[0-5]\\d\\s?(AM|PM)$', example: '11:30 PM' },
  { key: 'datetime_ymd_dash_Hm_doubledot', value: 'datetime_ymd_dash_Hm_doubledot', text: 'DateTime (YYYY-MM-DD HH:MM)', regex: '^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])\\s(0\\d|1\\d|2[0-3]):[0-5]\\d$', example: '2025-08-20 14:30' },
  { key: 'datetime_ymd_dash_Hms_doubledot', value: 'datetime_ymd_dash_Hms_doubledot', text: 'DateTime (YYYY-MM-DD HH:MM:SS)', regex: '^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])\\s([01]\\d|2[0-3]):([0-5]\\d):([0-5]\\d)$', example: '2025-08-20 14:30:45' },
  { key: 'datime_iso_full', value: 'datime_iso_full', text: 'DateTime ISO 8601', regex: '^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d+)?(Z|[+-]\\d{2}:\\d{2})$', example: '2025-08-20T14:30:00Z' },
  { key: 'week_no_in_year', value: 'week_no_in_year', text: 'Week Number (YYYY-Www)', regex: '^\\d{4}-W(0[1-9]|[1-4]\\d|5[0-3])$', example: '2025-W34' },
  { key: 'quarter_no_in_year', value: 'quarter_no_in_year', text: 'Quarter (YYYY-Qn)', regex: '^\\d{4}-Q[1-4]$', example: '2025-Q3' },
  { key: 'alphanumeric_no_space', value: 'alphanumeric_no_space', text: 'Alphanumeric Only', regex: '^[A-Za-z0-9]+$', example: 'Test123' },
  { key: 'letters_only', value: 'letters_only', text: 'Letters Only', regex: '^[A-Za-z]+$', example: 'Hello' },
  { key: 'uppercase_only', value: 'uppercase_only', text: 'Uppercase Only', regex: '^[A-Z]+$', example: 'ABCDEF' },
  { key: 'lowercase_only', value: 'lowercase_only', text: 'Lowercase Only', regex: '^[a-z]+$', example: 'abcdef' },
  { key: 'alphanumeric_with_space', value: 'alphanumeric_with_space', text: 'Alphanumeric + Space', regex: '^[A-Za-z0-9 ]+$', example: 'Test 123' },
  { key: 'nric_my', value: 'nric_my', text: 'MyKad (NRIC, Malaysia)', regex: '^\\d{6}-\\d{2}-\\d{4}$', example: '900101-14-5678' },
  { key: 'passport_generic', value: 'passport_generic', text: 'Passport No. (Generic)', regex: '^[A-Za-z0-9]{5,20}$', example: 'A1234567' },
  { key: 'brn_my', value: 'brn_my', text: 'Company Reg No. (MY)', regex: '^\\d{6,10}$', example: '1234567' },
  { key: 'tin_generic', value: 'tin_generic', text: 'TIN (Generic)', regex: '^[A-Za-z0-9-]{5,20}$', example: 'TIN-12345' },
  { key: 'zip_code_my', value: 'zip_code_my', text: 'Zip/Postal Code (MY)', regex: '^\\d{5}$', example: '88200' },
  { key: 'zip_code_intl', value: 'zip_code_intl', text: 'Zip/Postal Code (Intl)', regex: '^[A-Za-z0-9\\- ]{3,10}$', example: 'SW1A 1AA' },
  { key: 'url', value: 'url', text: 'URL', regex: '^(https?:\\/\\/)?([\\w.-]+)\\.([a-z]{2,})([/\\w .-]*)*\\/?$', example: 'https://example.com' },
  { key: 'ipv4', value: 'ipv4', text: 'IPv4', regex: '^((25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)(\\.|$)){4}$', example: '192.168.0.1' },
  { key: 'ipv6', value: 'ipv6', text: 'IPv6', regex: '^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$', example: '2001:0db8:85a3:0000:0000:8a2e:0370:7334' },
  { key: 'credit_card_no', value: 'credit_card_no', text: 'Credit Card No.', regex: '^(?:\\d[ -]?){13,19}$', example: '4111111111111111' },
  { key: 'drive_license_my', value: 'drive_license_my', text: 'Malaysian Driving License', regex: '^[A-Z]{1,2}\\d{6,8}$', example: 'B1234567' },
  { key: 'vehicle_plate_my', value: 'vehicle_plate_my', text: 'Vehicle Plate (MY)', regex: '^[A-Z]{1,3}\\d{1,4}[A-Z]?$', example: 'WXY1234A' },
  { key: 'invoice_no_generic', value: 'invoice_no_generic', text: 'Invoice No.', regex: '^[A-Za-z0-9\\-/]{3,20}$', example: 'INV-2025/001' },
  { key: 'booking_ref_code', value: 'booking_ref_code', text: 'Booking Ref Code', regex: '^[A-Z]{3}-\\d{6}$', example: 'ABC-123456' },
  { key: 'hex_color_code', value: 'hex_color_code', text: 'Hex Color Code', regex: '^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$', example: '#FF5733' },
  { key: 'otp_six_digits', value: 'otp_six_digits', text: 'OTP (6 digits)', regex: '^\\d{6}$', example: '123456' },
  { key: 'uuid_v4', value: 'uuid_v4', text: 'UUID (v4)', regex: '^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', example: '550e8400-e29b-41d4-a716-446655440000' },
  { key: 'mac_address', value: 'mac_address', text: 'MAC Address', regex: '^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$', example: '00:1A:2B:3C:4D:5E' },
  { key: 'hostname', value: 'hostname', text: 'Hostname', regex: '^([a-zA-Z0-9-]{1,63}\\.)+[a-zA-Z]{2,}$', example: 'myhost.local' },
  { key: 'subnet_cidr', value: 'subnet_cidr', text: 'Subnet (CIDR)', regex: '^((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(?!$)|$)){4}\\/(3[0-2]|[12]?\\d)$', example: '192.168.1.0/24' },
  { key: 'custom', value: 'custom', text: 'Custom (Regex)', regex: '', example: '' },
];

export const VALIDATION_TYPE_DICT = VALIDATION_TYPE_MAP.reduce((acc, item) => ({ ...acc, [item.value]: item }), {});

/** Extracts [day, month, year] from a date string based on the format key.*/
const extractDateParts = (value, formatKey) => {
  const parts = value.split(/[/\-.\sTZ]/).map(Number);

  // Map each format key to [day, month, year] using the correct positions
  const formatToDateParts = {
    // DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY -> parts[0]=day, parts[1]=month, parts[2]=year
    date_dmy_slash: [parts[0], parts[1], parts[2]],
    date_dmy_dash: [parts[0], parts[1], parts[2]],
    date_dmy_dot: [parts[0], parts[1], parts[2]],

    // MM/DD/YYYY -> parts[0]=month, parts[1]=day, parts[2]=year
    date_mdy_slash: [parts[1], parts[0], parts[2]],

    // YYYY/MM/DD, YYYY-MM-DD -> parts[0]=year, parts[1]=month, parts[2]=day
    date_ymd_slash: [parts[2], parts[1], parts[0]],
    date_ymd_dash: [parts[2], parts[1], parts[0]],

    // MM-YYYY -> parts[0]=month, parts[1]=year (no day, use 1)
    date_my_dash: [1, parts[0], parts[1]],

    // YYYY-MM -> parts[0]=year, parts[1]=month (no day, use 1)
    date_ym_dash: [1, parts[1], parts[0]],

    // YYYY-MM-DD HH:MM / YYYY-MM-DD HH:MM:SS / ISO 8601
    datetime_ymd_dash_Hm_doubledot: [parts[2], parts[1], parts[0]],
    datetime_ymd_dash_Hms_doubledot: [parts[2], parts[1], parts[0]],
    datetime_iso_full: [parts[2], parts[1], parts[0]],
  };

  // Special handling for "Month DD, YYYY" (e.g. "August 03, 2025")
  if (formatKey === 'date_Mdy_space') {
    const match = value.match(/^(\w+)\s(\d{2}),\s(\d{4})$/);
    if (!match) return null;

    const monthNames = [
      'january', 'february', 'march', 'april', 'may', 'june',
      'july', 'august', 'september', 'october', 'november', 'december',
    ];
    const monthIndex = monthNames.indexOf(match[1].toLowerCase()) + 1;
    if (monthIndex === 0) return null;

    return [Number(match[2]), monthIndex, Number(match[3])];
  }

  return formatToDateParts[formatKey] || null;
};

/** Validates whether day/month/year is a real calendar date.*/
const isValidCalendarDate = (day, month, year) => {
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year
    && date.getMonth() === month - 1
    && date.getDate() === day
  );
};

export const checkRegex = (value, data) => {
  if (!value || !data || !data.regex) {
    return { isValid: true, message: null };
  }

  const formatEntry = VALIDATION_TYPE_DICT[data.formatName];

  // Step 1: Check if value matches the expected format pattern (e.g. DD/MM/YYYY)
  const regexValid = new RegExp(data.regex).test(value);
  if (!regexValid) {
    return {
      isValid: false,
      message: `${data.label} must be a valid ${formatEntry.text}${formatEntry.value === 'custom' ? `: ${data.regex}` : ''}`,
    };
  }

  // Step 2: For date formats, also validate the actual calendar date.
  const dateParts = extractDateParts(value, data.formatName);
  if (dateParts) {
    const [day, month, year] = dateParts;
    if (!isValidCalendarDate(day, month, year)) {
      return {
        isValid: false,
        message: `${data.label} must be a valid ${formatEntry.text}`,
      };
    }
  }

  return { isValid: true, message: null };
};

class RegexDropdownPicker extends Component {
  componentWillUnmount() {
    // clean up timeout when unmount
    clearTimeout(this.typingTimeout);
  }

  typingTimeout = null;

  handleOnFormatChange = (e, { value }) => {
    const selected = VALIDATION_TYPE_DICT[value];

    this.props.onChange(e, { validationFormat: selected });
  };

  handleOnRegexChange = (e, { value }) => {
    if (this.props.formatValue === VALIDATION_TYPE_DICT.custom.value) {
      this.props.onChange(e, {
        validationFormat: {
          ...VALIDATION_TYPE_DICT.custom,
          regex: value,
        },
      });
    }

    // Optional debounced side-effect (e.g. validation, API)
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => {
      console.log('Debounced side effect with regex:', value);
      // you can trigger validation/API here instead
    }, 300);
  };

  render() {
    const { t, formatValue, regexValue } = this.props;

    return (
      <Form.Group>
        <Form.Field width={8}>
          <Form.Select
            fluid
            search
            name="formatPicker"
            label={t('Validation Type', { ns: TRANSLATION_FILES.screens })}
            options={VALIDATION_TYPE_MAP}
            value={formatValue || VALIDATION_TYPE_MAP[0].value}
            onChange={this.handleOnFormatChange}
          />
        </Form.Field>

        {formatValue === 'custom' && (
          <Form.Field width={8}>
            <Form.Input
              fluid
              name="regexInput"
              label={t('Custom Regex', { ns: TRANSLATION_FILES.screens })}
              value={regexValue}
              onChange={this.handleOnRegexChange}
            />
          </Form.Field>
        )}
      </Form.Group>
    );
  }
}

RegexDropdownPicker.propTypes = {
  t: PropTypes.func.isRequired,
  formatValue: PropTypes.string,
  regexValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

RegexDropdownPicker.defaultProps = {
  formatValue: '',
  regexValue: '',
};

export default withTranslation(namespaces)(RegexDropdownPicker);



// WEBPACK FOOTER //
// ./src/components/RegexDropdownPicker.jsx